import { postRequest } from '~/shared/utils';

export async function verifyResetPasswordSecret(apiUrl: string, headers?: HeadersInit) {
    const request = await postRequest<boolean, Record<string, string>>(apiUrl, {}, headers);

    const response = await request();

    return response;
}
